module.exports = __webpack_public_path__ + "img/dem.e91296b7.jpg";